let scrollPosition = 0;
let body;
const DISABLE_SCROLLING_CLASS = "scroll-disabled";

export default {
  enable() {
    body = document?.querySelector?.("body");
    if (!body) return;

    scrollPosition = window.pageYOffset;

    body.classList.add(DISABLE_SCROLLING_CLASS);
    body.style.top = `-${scrollPosition}px`;
    body.style.width = "100%";
  },

  disable() {
    if (!body) return;

    body.classList.remove(DISABLE_SCROLLING_CLASS);
    body.style.removeProperty("top");
    body.style.removeProperty("width");
    body.style.removeProperty("position");
    body.style.removeProperty("overflow");

    window.scrollTo(0, scrollPosition);
  },
};
